export default __webpack_public_path__ + "static/media/s3Bucket.449b9845.svg";